import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

export type StackableRowProps = {
  children?: React.ReactNode;
  /**
   * Gives the main item a row to itself and drops the ones either side of it onto the next.
   *
   * **The column tracks are the same either way** - only which cell each item sits in changes, so
   * they all arrive in one layout pass. A wrapping flex row reaches the same shape by letting each
   * item find its own place, which is what makes the outer items appear to move one at a time.
   */
  isStacked?: boolean;
  name?: string;
};

/**
 * A row of three: something either side of one item that grows into whatever they leave it. On
 * `isStacked` the middle one takes the whole row and the other two drop beneath it.
 *
 * **It is told when to stack rather than working it out**, because what counts as outgrowing the
 * row belongs to whatever is in the middle - a field's line count, a label's width - and only that
 * thing can say.
 */
export const StackableRow = ({
  children,
  isStacked,
  name,
}: StackableRowProps) => (
  <div
    className={AttrsHelper.formatClassname(
      'stackable-row',
      isStacked && 'stackable-row-stacked'
    )}
    data-test={name}
  >
    {children}
  </div>
);
